export function validateCoordinates(lat: number, lng: number): void {
  if (
    typeof lat !== 'number' ||
    typeof lng !== 'number' ||
    isNaN(lat) ||
    isNaN(lng)
  ) {
    throw new Error('Latitude and longitude must be valid numbers.');
  }

  if (lat < -90 || lat > 90) {
    throw new Error('Latitude must be between -90 and 90 degrees.');
  }

  if (lng < -180 || lng > 180) {
    throw new Error('Longitude must be between -180 and 180 degrees.');
  }
}
